import React, { useState, useEffect } from "react";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ThemMoiTaiKhoan } from "./ThemMoiTaiKhoan";
import { PopoversBootrap } from "../../../components/GenericComponent/PopoversBootrap";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";

export const ContentTable = ({ dataDanhSach, onSearch }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const ShowConfirmDelete = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const [isShowModalQRThanhToanHD, setIsShowModalQRThanhToanHD] =
    useState(false);
  const [hopdong, setDataHopDong] = useState({});
  const toggleModalQRThanhToanHD = () => {
    setIsShowModalQRThanhToanHD(!isShowModalQRThanhToanHD);
  };
  const setModalQRThanhToanShow = (hopdong) => () => {
    setDataHopDong(hopdong);
    toggleModalQRThanhToanHD();
  };
  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteChoThanhToan = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  };
  //Phần  lien kết ngân hàng
  const showDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalLienKet();
  };
  const [isModalLienKet, setModalLienKet] = useState(false);
  const toggleModalLienKet = () => {
    setModalLienKet(!isModalLienKet);
  };
  // end lien kết ngân hàng

  //Phần huy lien kết ngân hàng
  const showHuyDangKyPushBDSD = (item) => {
    setDataFocus(item);
    toggleModalHuyLienKet();
  };
  const [isModalHuyLienKet, setModalHuyLienKet] = useState(false);
  const toggleModalHuyLienKet = () => {
    setModalHuyLienKet(!isModalHuyLienKet);
  };
  // end lien kết ngân hàng

  return dataDanhSach.List.map((item, index) => (
    <div className="custom-table-row" key={item.Id}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{index + 1}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-20 flex-basis-20-sm">
        <span className="mobile-column-name">Mã hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center color-xanh-do">{item.Code}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Họ và tên</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.CustomerName}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Số tiền cần thanh toán</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.TongTien}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Loại thanh toán</span>
        <div className="center-wrapper">
          {item.LoaiThanhToan == "TatToan" && (
            <p className="text-center color7">Tất toán</p>
          )}
          {item.LoaiThanhToan == "DongLai" && (
            <p className="text-center color7">Đóng lãi</p>
          )}
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
        <span className="mobile-column-name">Loại hợp đồng</span>
        <div className="center-wrapper">
          {item.LoaiHopDong == "1" && (
            <p className="text-center color7">Tín chấp</p>
          )}
          {item.LoaiHopDong == "2" && (
            <p className="text-center color7">Trả góp</p>
          )}
          {item.LoaiHopDong == "3" && (
            <p className="text-center color7">Cầm đồ</p>
          )}
          {item.LoaiHopDong == "5" && (
            <p className="text-center color7">Bán hàng trả góp</p>
          )}
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm ">
        <span className="mobile-column-name ">Trạng thái</span>
        <div className="center-wrapper">
          {item.TrangThai == "ChuaThucHien" && (
            <p className="text-center color7">Chưa thanh toán</p>
          )}
          {item.TrangThai == "HoanThanh" && (
            <p className="text-center color7">Đã thanh toán</p>
          )}
        </div>
      </div>
      <div className="custom-table-cell flex-basis-10 flex-basis-10-sm ">
        <span className="mobile-column-name">Ngày tạo</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.NgayTao}</p>
        </div>
      </div>
      <div className="custom-table-cell flex-basis-15 flex-basis-15-sm ">
        <span className="mobile-column-name">Thao Tac</span>
        <div
          className="center-wrapper text-center color7"
          style={{ fontSize: "20px" }}
        >
          <a
            className="dropdown-item"
            onClick={setModalQRThanhToanShow(item)}
            href={() => false}
          >
            <PopoversBootrap
              contentText="QR thanh toán"
              titleText=""
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <i className="mdi mdi-qrcode"></i>
            </PopoversBootrap>
          </a>

          <a
            href={() => false}
            onClick={(e) => deleteChoThanhToan(item)}
            style={{ marginRight: "5px" }}
          >
            <PopoversBootrap
              contentText="Xóa"
              titleText=""
              trigger={["hover", "focus"]}
              placement={"top"}
            >
              <img
                style={{ marginLeft: "5px" }}
                src="/app-assets/images/icon-xoa-v2.png"
              />
            </PopoversBootrap>
          </a>
        </div>
      </div>
      <ModalXoa
        isModalVisible={isModalXoa}
        onSearch={onSearch}
        toggleModal={toggleModalXoa}
        item={dataFocus}
      />
      <ModelQRThanhToanHD
        show={isShowModalQRThanhToanHD}
        onHide={toggleModalQRThanhToanHD}
        hopdong={hopdong}
      />
    </div>
  ));
};
